/*
 * Format raw metrics to custom/additional metric field(s) that can be
 * used to extend the original metrics data to be used for report.
 */
export function getCanceledMetrics(periods, metrics) {
    const canceled = 'canceled';
    let periodMetric = {};
    for (let period of periods) {
        const total_jobs = metrics['jobs_' + period.name].doc_count;
        const canceled_jobs = metrics['canceled_' + period.name][canceled].doc_count;
        const value = Math.round(canceled_jobs / total_jobs * 100);
        periodMetric[canceled + '_' + period.name] = {};
        periodMetric[canceled + '_' + period.name][canceled] = { value: value };
    }
    return periodMetric;
}
export function transformBOLTardiness(periods, metrics) {
    function initializeBOLMetrics(periods) {
        const requiredKeys = ['bol_tardiness_12hours', 'bol_tardiness_24hours'];
        let bolMetrics = {};
        for (const period of periods) {
            for (const requiredKey of requiredKeys) {
                bolMetrics[requiredKey + '_' + period.name] = {};
                bolMetrics[requiredKey + '_' + period.name][requiredKey] = {
                    value: 0,
                };
            }
        }
        return bolMetrics;
    }
    function getKeyFromBucketKey(bucketKey) {
        if (bucketKey === '12hours')
            return 'bol_tardiness_12hours';
        else if (bucketKey === '24hours')
            return 'bol_tardiness_24hours';
    }
    function getTotalDeliveredCount(buckets) {
        let total = 0;
        for (const bucket of buckets) {
            total += bucket.doc_count;
        }
        return total;
    }
    let bolMetrics = initializeBOLMetrics(periods);
    for (const period of periods) {
        const totalDeliveredCount = getTotalDeliveredCount(metrics['bol_tardiness_' + period.name].bol_tardiness.buckets);
        for (const bucket of metrics['bol_tardiness_' + period.name].bol_tardiness.buckets) {
            const key = getKeyFromBucketKey(bucket.key);
            let bucketCount = bucket.doc_count;
            if (bucket.key === '12hours') {
                const under24HoursBucketKey = getKeyFromBucketKey('24hours');
                bolMetrics[under24HoursBucketKey + '_' + period.name][under24HoursBucketKey].value += Math.round(bucketCount / totalDeliveredCount * 100);
            }
            if (key === undefined)
                continue;
            bolMetrics[key + '_' + period.name][key].value += Math.round(bucketCount / totalDeliveredCount * 100);
        }
    }
    return bolMetrics;
}
;
export function getPickupOnTimeMetrics(periods, metrics) {
    const onTimeName = 'pickup_on_time';
    let periodMetric = {};
    for (let period of periods) {
        const aggData = metrics['total_picked_up_' + period.name]['total_picked_up'];
        const value = Math.round(aggData['on_time_pickup'].doc_count / aggData.doc_count * 100);
        periodMetric[onTimeName + '_' + period.name] = {};
        periodMetric[onTimeName + '_' + period.name][onTimeName] = { value: value };
    }
    return periodMetric;
}
export function getDeliveryOnTimeMetrics(periods, metrics) {
    const onTimeName = 'delivery_on_time';
    let periodMetric = {};
    for (let period of periods) {
        const aggData = metrics['total_delivered_' + period.name]['total_delivered'];
        const value = Math.round(aggData['on_time_delivery'].doc_count / aggData.doc_count * 100);
        periodMetric[onTimeName + '_' + period.name] = {};
        periodMetric[onTimeName + '_' + period.name][onTimeName] = { value: value };
    }
    return periodMetric;
}
export function getPhoneUseMetrics(periods, metrics) {
    const fieldName = 'phone_used';
    let periodMetric = {};
    for (let period of periods) {
        const aggData = metrics['phone_use_' + period.name];
        const value = Math.round(aggData['phone_use'].doc_count / aggData.doc_count * 100);
        periodMetric[fieldName + '_' + period.name] = {};
        periodMetric[fieldName + '_' + period.name][fieldName] = { value: value };
    }
    return periodMetric;
}
